var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#141bf0",
    height: "156px",
    width: "156px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 399.855 399.855",
    xmlSpace: "preserve",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    stroke: "#141bf0",
    strokeWidth: 0.003998550000000001,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.441,179.623c-4.018-4.658-9.751-7.463-15.861-7.795V124.74c0-22.943-18.662-41.607-41.603-41.607h-8.846V54.33 c0-2.898-1.149-5.68-3.2-7.727L256.528,3.197C254.477,1.15,251.701,0,248.799,0H118.183c-11.833,0-21.46,9.627-21.46,21.461v87.033 H83.351c-20.444,0-37.077,16.209-37.077,36.133v27.201c-6.107,0.332-11.842,3.137-15.861,7.795 c-4.29,4.975-6.203,11.568-5.24,18.064l27.097,182.895c1.641,11.072,11.144,19.273,22.338,19.273h250.64 c11.195,0,20.699-8.201,22.34-19.273l27.098-182.895C375.646,191.191,373.734,184.598,369.441,179.623z M233.618,23.892v32.126 c0,7.781,6.308,14.085,14.083,14.085h32.125v101.692H120.027V23.892H233.618z M73.461,171.795v-27.168 c0-5.598,5.028-8.943,9.89-8.943h13.372v36.111H73.461z M326.395,171.795h-23.264v-61.473h8.846c7.947,0,14.418,6.466,14.418,14.418 V171.795z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodata);
export default __webpack_public_path__ + "static/media/Nodata.19e705a018fed9785fb0daac73170e36.svg";
export { ForwardRef as ReactComponent };